
export interface TabBarItemData {
    id: number;

}

export interface TabBarOptions<Data extends TabBarItemData = any> {
    container: HTMLElement;
    items?: TabBarItemOptions<Data>[];
    direction?: "vertical" | "horizontal";
    onSelect?: (data: Data) => void;
}

export interface TabBarItemOptions<Data extends TabBarItemData = any> {
    data: Data;
    label: string;
}

export class TabBar<Data extends TabBarItemData = any>{

    public onSelect = e5.Signal.create<[Data]>();

    private _element: HTMLElement;
    private _items: TabBarItem<Data>[] = [];
    private _current: TabBarItem<Data> = null;

    constructor(options: TabBarOptions) {
        options = e5.object.merge({
            direction: "horizontal"
        }, options);
        this._element = document.createElement("div");
        this._element.className = "tab-bar";
        this._element.classList.add("tab-bar--" + options.direction);
        this._element.innerHTML = `
        <div class="tab-bar__list"></div>
        `;

        if (options.items) {
            for (let item of options.items) {
                this.add(item);
            }
        }

        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public add(options: TabBarItemOptions<Data>): TabBarItem<Data> {
        const item = new TabBarItem(options);
        this._element.querySelector(".tab-bar__list").append(item.element);
        this._items.push(item);
        item.element.addEventListener("click", () => {
            if (item.selected) {
                return;
            }
            this.current = options.data;
        });
        return item;
    }

    private get(data: Data): TabBarItem<Data> | null {
        for (let item of this._items) {
            if (item.data.id == data.id) {
                return item;
            }
        }
        return null;
    }

    public get current(): Data {
        return this._current?.data;
    }

    public set current(value: Data) {

        let c = this.get(value);
        if (this._current === c) {
            return;
        }

        if (this._current) {
            this._current.selected = false;
        }

        this._current = c;

        if (this._current) {
            this._current.selected = true;
            this.onSelect.dispatch(value);
            this._current.element.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
}

class TabBarItem<Data extends TabBarItemData = any>{
    public readonly element: HTMLElement;
    public readonly data: Data;

    constructor(options: TabBarItemOptions) {
        this.element = document.createElement("div");
        this.element.className = "tab-bar__item";
        this.element.innerHTML = options.label;
        this.data = options.data;
    }

    public get selected(): boolean {
        return this.element.classList.contains("tab-bar__item--selected");
    }

    public set selected(value: boolean) {
        this.element.classList.toggle("tab-bar__item--selected", value);
    }
}